import script from "./ExtraInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ExtraInfo.vue?vue&type=script&setup=true&lang=js"

import "./ExtraInfo.vue?vue&type=style&index=0&id=2770a097&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2770a097"]])

export default __exports__